import React, { useState } from "react";
import "./TryIt.css";
import {
  makeLegalSummarizeRequest,
  makeSummarizePDFsRequest,
  makeSummarizeRequest,
  makeLegalSummarizePDFsRequest,
  uploadSummarizePDF
} from "../../utils/apiCalls";
import Loader from "./Loader/Loader";
import Accordion from "./Accordion";
import urlIcon from '../../assets/url.svg'
import diskIcon from '../../assets/disk.svg'
import { Copy } from 'lucide-react';
import Result from "./Result/Result";
import FileUpload from "../FileUpload/FileUpload";
const TryIt = () => {
  const [search, setSearch] = useState("");
  const [responseData, setResponseData] = useState([])
  const [loading, setLoading] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [pdfFile, setPdfFile] = useState(null);
  const [isLegal, setIsLegal] = useState(false);

  const handleInputClick = async () => {
    try {
      if (search.trim() === '') {
        const text = await navigator.clipboard.readText();
        setSearch(text);
      }
    } catch (err) {
      console.error('Failed to paste content: ', err);
    }
  };
  const handleLegalSummarizeSubmit = async () => {
    if (search.trim() === "") return;
    try {
      setLoading(true)
      const pdfUrls = search.split(' ')
      const { data } = await makeLegalSummarizeRequest({ 'pdf_urls': pdfUrls });
      const preData = await preSetResponseData(data)
      setResponseData(preData)
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false)
      setSearch("");
    }
  };

  const handleSummarizeSubmit = async () => {
    if (search.trim() === "") return;
    try {
      setLoading(true)
      const pdfUrls = search.split(' ')
      const { data } = await makeSummarizeRequest({ 'pdf_urls': pdfUrls });
      const preData = await preSetResponseData(data)
      setResponseData(preData)
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false)
      setSearch("");
    }
  };

  const handleSummarize = async () => {
    if (pdfFile) {
      setLoading(true)
      setSearch(pdfFile.name)
      const { data } = await uploadSummarizePDF(pdfFile, isLegal ? 'legal' : 'default');
      const preData = await preSetResponseData(data)
      setResponseData(preData)
      setPdfFile(null);
      setLoading(false)
    } else {
      if (isLegal) {
        handleLegalSummarizeSubmit()
      } else {
        handleSummarizeSubmit()
      }
    }
  }

  const handleSearch = (searchQuery) => {
    console.log('searchQuery: ', searchQuery)
    if (searchQuery.trim() === "") return;

    setResponseData((prev) => {
      const newArr = [...prev];

      const sorted = newArr.toSorted((a, b) => {
        switch (true) {
          case a.filename.toLowerCase().includes(searchQuery.toLowerCase()):
            return -1;
          case b.filename.toLowerCase().includes(searchQuery.toLowerCase()):
            return 1;
          case a.summary.toLowerCase().includes(searchQuery.toLowerCase()):
            return -1;
          case b.summary.toLowerCase().includes(searchQuery.toLowerCase()):
            return 1;
          case a.topic.toLowerCase().includes(searchQuery.toLowerCase()):
            return -1;
          case b.topic.toLowerCase().includes(searchQuery.toLowerCase()):
            return 1;
          case a.classification.toLowerCase().includes(searchQuery.toLowerCase()):
            return -1;
          case b.classification.toLowerCase().includes(searchQuery.toLowerCase()):
            return 1;
          default:
            return 0;
        }
      });

      return sorted;
    });
  };

  const handleSummarizePDFsSubmit = async () => {
    try {
      setLoading(true)
      const { data } = await makeSummarizePDFsRequest(isFirstTime);
      const preData = await preSetResponseData(data)
      setResponseData(preData)
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false)
      setIsFirstTime(false)
    }
  };

  const handleLegalSummarizeFileSelect = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];
    setPdfFile(file);
    setSearch(file.name)
    setLoading(true)
    const { data } = await uploadSummarizePDF(file, 'legal');
    const preData = await preSetResponseData(data)
    setResponseData(preData)
    setPdfFile(null);
    setSearch("")
    setLoading(false)
  };

  const handleSummarizeFileSelect = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];
    setPdfFile(file);
    setSearch(file.name)
  };

  const handleLegalSummarizePDFsSubmit = async () => {
    try {
      setLoading(true)
      const { data } = await makeLegalSummarizePDFsRequest(isFirstTime);
      const preData = await preSetResponseData(data)
      setResponseData(preData)
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false)
      setIsFirstTime(false)
    }
  };

  const preSetResponseData = async (data) => {
    const resultArr = []
    for (const index in data.filename) {
      let obj = {
        'filename': data?.filename[index] || '',
        'summary': data?.summary[index] || '',
        'topic': data?.topic[index] || '',
        'url': data?.url[index] || '',
        'classification': data?.classification[index].replace(/\*/g, "") || '',
      }
      let topic = obj.topic;
      topic = topic.replace("The topic of the text is", "");
      topic = topic.replace('"', " ");
      topic = topic.replace('".', "");
      obj.topic = topic.toUpperCase();
      resultArr.push(obj)
    }

    return resultArr
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setPdfFile(null);
      setSearch(text)
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };


  return (
    <div className="try">
      <div className="try__container">
        <h1 className="try__title">Try It Yourself!</h1>
        <p className="try__text">
          Please enter the questions in the input below.
        </p>
        <div className="try__input">
          <input
            className="try__search"
            id="searchWidgetTrigger"
            type="text"
            placeholder="Please enter link here or upload a pdf file"
            value={search}
            onChange={({ target }) => setSearch(target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && search.trim() !== '') {
                handleSummarize();
              }
            }}
          />
          <div className="try__btn_summarize" onClick={handleSummarize}>
            <span>Summarize</span>
          </div>
        </div>

        <div className="try__actions">
          <div className="action__legal">
            <input type="checkbox" className="try__checkbox" id="legal-checkbox" onChange={(e) => setIsLegal(e.target.checked)} />
            <label className="try__btn_label" htmlFor="legal-checkbox">Legal</label>
          </div>
          <div className="try__btn__buttons">
            <FileUpload onChange={handleSummarizeFileSelect} file={pdfFile?.filename || ""} />
          </div>
          <div className="try__btn-example">
            <div onClick={() => copyToClipboard("https://www.compensair.com/documents/Compensair/en/TermsConditions_Compensair_en.pdf")}>Copy Example Link</div>
            <Copy size={20} color="#979797"
              onClick={() => copyToClipboard("https://www.compensair.com/documents/Compensair/en/TermsConditions_Compensair_en.pdf")}
              style={{ cursor: 'pointer', marginLeft: '20px' }}
            />
          </div>
        </div>
        <Result items={responseData} handleSearch={handleSearch} />
        {/* <Accordion items={responseData} /> */}
      </div>
      <Loader loading={loading} />
    </div>
  );
};

export default TryIt;
